import axios from "../../../../../axios";
import Cookies from "js-cookie";

export const GetAllReceivedCandidate = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetAllReceivedCandidates", {
    token,
  });
};